import axios from 'axios-https-proxy-fix';
// import _ from 'lodash';
import https from 'https';
// import getProxy from '../getProxy';
import debug from './debug';

const apiService = {};

apiService.getRequestOptions = (params, headers = {}) => {
    return {
        params,
        // proxy: getProxy(),
        headers,
        json: true,
        httpsAgent: new https.Agent({
            rejectUnauthorized: false,
        }),
    };
};

apiService.get = async (url, params = {}, headers) => {
    const reqOptions = apiService.getRequestOptions(params, headers);

    debug(`GET ApiService request from API ${url}`);

    if (params) {
        debug(`GET ApiService request URL parameters ${JSON.stringify(params)}`);
    }

    try {
        const response = await axios.get(url, reqOptions);
        debug(`GET ApiService request from API ${response.data}`);
        return response.data;
    } catch (error) {
        debug(`GET ApiService error from API ${error}`);
    }
    return {};
};

apiService.post = async (url, params = {}, headers) => {
    const reqOptions = apiService.getRequestOptions({}, headers);

    debug(`POST ApiService request from API ${url}`);

    if (params) {
        debug(`POST ApiService request URL parameters ${JSON.stringify(params)}`);
    }

    try {
        const response = await axios.post(url, params, reqOptions);
        debug(`POST ApiService request from API ${response.data}`);
        return response.data;
    } catch (error) {
        debug(`POST ApiService error from API ${error}`);
    }
    return {};
};

export default apiService;
